<template>
    <div class="supply_wrap">
        <div class="LookMenuStyle" id="app">
            <top-component ref="topRef"></top-component>
            <!-- <top-component-tch ref="topRef" v-if="logintype ==0"></top-component-tch> -->
            <div class="suppldetaiboxd">
                <div class='suppldetaibox'>
                    <div class="content_wrap">
                        <h2 v-if="TitleName" style="color:#fff;padding-bottom:16px;">{{ TitleName }}</h2>
                        <SearchComponent1 @submitForm="submitForm" @fileChange="fileChange" :filechange="filechange" :isShowType="isShowType" :showchubanshe = 'showchubanshe' :showpubname="showpubname" :paramss = 'params' ></SearchComponent1>   
    
                        <p v-if="defaultAddress" style="font-size:12px;padding-left:20px;color:#999;padding-top:10px;">您当前默认收货地址：
                            <span style="color:#333;">{{ defaultAddress }}</span>
                            <span style="color:#ff0000;padding-left:10px;text-decoration:underline;cursor: pointer;" @click="goChangeAddress">修改默认地址></span>
                        </p>
                        <!-- <div class="titleName" v-if="!filechange">
                            <div class="changeMode">
                                <span class="listfont" :class="{'filecurrent':filechange}" @click="fileChange(1)"><i class="boxIcon"></i></span>
                                <span class="listfont" :class="{'filecurrent':!filechange}" @click="fileChange(2)"><i class="listIcon"></i></span>
                            </div>
                        </div> -->
                        <div class="list_wrap" v-if="filechange">
                            <!-- <div class="tab clearfixed">
                                <el-table ref="djSort" class="fl" :data="tableData" style="width: 180px" @sort-change="filterChange">
                                    <el-table-column prop="dj" label="定价" sortable width="80"></el-table-column>
                                    <el-table-column prop="cbny" label="出版时间" sortable width="100"></el-table-column>
                                </el-table>
                                <el-form label-position="right" label-width="0px" :model="params" style="float:left;margin-top: 10px; display: flex; align-items: center;">
                                    <el-form-item label="" class="itemline" style="font-weight: 700; margin-bottom: 0px;width:120px;">
                                        <div style="display:flex; align-items: center;position:relative;">
                                            <el-input size="mini" style="position:relative ;" v-model="params.isbns" placeholder="可输入多个ISBN" readonly @click.native="multiplePop('ISBN','isbns')"></el-input>
                                            <i v-if="params.isbns" class="el-icon-circle-close circleclose" style="position: absolute;color:#ececec; right:5px;" @click="clearValue('isbns')"></i>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="" class="itemline" style="font-weight: 700; margin-bottom: 0px;">
                                        <div style="display: flex; align-items: center;">
                                            <DatePicker type="month" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 120px;" :picker-options="startTime" v-model="params.pubfrom"></DatePicker>
                                            <span class="line">~</span>
                                            <DatePicker type="month" size="mini" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 120px;" :picker-options="endTime" v-model="params.pubto"></DatePicker>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="" class="itemline" style="font-weight: 700; margin-bottom: 0px;">
                                        <div style="display: flex; align-items: center;">
                                            <el-input size="mini" v-model="params.myfrom" clearable style="width: 65px;"></el-input>
                                            <span class="line">~</span>
                                            <el-input size="mini" v-model="params.myto" clearable style="width: 65px;"></el-input>
                                            <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">元</i>
                                        </div>
                                    </el-form-item>
                                    <el-form-item label="" style="font-weight: 700; margin-bottom: 0px; margin-right: 10px;">
                                        <div style="display: flex; align-items: center;">
                                            <el-input size="mini" v-model="params.min" clearable style="width: 65px;"></el-input>
                                            <span class="line">~</span>
                                            <el-input size="mini" v-model="params.max" clearable style="width: 65px; "></el-input>
                                            <i class="font" style="font-weight:400 ;font-style: normal; margin-left: 5px;">cm</i>
                                        </div>
                                    </el-form-item>
                                    <div class="search-btn">
                                        <Button type="primary" plain size="mini" @click="onSubmitResult" class="submit-btn">确定</Button>
                                    </div>
                                </el-form>
                                <div class="showData" style="position: absolute;top:18px;right:100px;font-size: 14px; color: #666;">收录图书<b style="color:#ff1616;padding:0 3px;">5916278</b>种</div>
                                <div class="changeMode" v-if="filechange">
                                    <span class="listfont" :class="{'filecurrent':filechange}" @click="fileChange(1)"><i class="boxIcon"></i></span>
                                    <span class="listfont" :class="{'filecurrent':!filechange}" @click="fileChange(2)"><i class="listIcon"></i></span>
                                </div>
                            </div>
                            <div v-if="isNonedatas" class="nonedata">
                                <p>暂无数据！</p>
                            </div> -->
                            <div class="pagefixed cleaxfix" id="pageFixed" v-if="!isNonedatas">
                                <Checkbox class="bigCheckbox fl" v-model="checkAll" :indeterminate="isIndeterminate" size="small" @change="changeCheckAll">全选</Checkbox>
                                <el-pagination class="fr" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="params.current" :page-size="params.size" layout="prev, pager, next, jumper, total" :total="total"></el-pagination>
                                <el-button v-if="adminState == 0 || adminState == 1" class="plbtn fl" type="warning" plain @click="multiAdd('0')" size="mini">批量加入购物车</el-button>
                                <el-button v-if="adminState == 2 || adminState == 3 || adminState == 4 || adminState == 5" class="plbtn fl" type="warning" plain @click="multiAdd('0')" size="mini">批量荐购</el-button>
                                <p v-if="defaultAddress" style="margin-left:180px;font-size:12px;color:#999;padding-top:5px;">您当前默认收货地址：
                                    <span style="color:#333;">{{ defaultAddress }}</span>
                                    <span style="color:#ff0000;padding-left:10px;text-decoration:underline;cursor: pointer;" @click="goChangeAddress">切换默认地址></span>
                                </p>
                                <!-- <el-button type="warning" plain @click="multiAdd('1')" size="mini">全部加入购物车</el-button> -->
                            </div>
                            <div class="LookMenu-container" id="bookList" v-if="!isNonedatas">
                                <div class="LookMenuSelf" v-for="(item,index) in dataArr" :key="index" :title="item.title">
                                    <Checkbox class="bigCheckbox" v-model="item.ckb" @change="changeCheck(index)"></Checkbox>
                                    <span v-if="item.delivery == '期货' " class="delivery">{{item.delivery}}</span>
                                    <span v-if="item.delivery == '现货' " class="newdelivery">{{item.delivery}}</span>
                                    <span class="orderedTip" v-if="item.selectNum>0">{{adminState == '0' || adminState == '1' ? '已订购' : '已荐购'}}</span>
                                    <div class="imgBacgr" @click="BookDetailClick(item)">
                                        <div v-if="item.isImageUrl">
                                            <img v-if="item.imageUrl" :src="item.imageUrl" @error="errorHandler" class="ImgStyle" alt="">
                                        </div>
                                        <div v-else>
                                            <div class="fmInfo" v-if="!item.isImageUrl">
                                                <h2 class="title">{{item.title}}</h2>
                                                <h2 class="author">{{item.author}}</h2>
                                                <h2 class="publisher">{{item.publisher}}</h2>
                                                <img :src="item.imageUrl" @error="errorHandler" class="ImgStyle" alt="">
                                            </div>
                                        </div>
                                        <!-- <img v-if="item.imageUrl" :src="item.imageUrl" alt /> -->
                                    </div>
                                    <div class="bookinfo">
                                        <div class="ImgTitle">{{item.title}}</div>
                                        <div class="ImgAdress">{{item.publisher}}</div>
                                        <div class="ImgAdress">{{item.publishTime}}</div>
                                        <div class="ImgMoney">￥{{item.price}}</div>
                                        <div class="textNum">(总订购{{item.allNum}}次)</div>
                                        <div class="buttonDiv">
                                            <el-button v-if="params.goodsType == 2 || (params.goodsType == 1 && item.unionGid)" type="primary" plain size="mini" @click="TryBook(item)">试读</el-button>
                                            <!-- <el-button v-if="item.selectNum>0" style="background-color:#D3D3D3 ;" type="warning" plain @click="multiAdd(item.goodsId)" size="mini" >加入购物车</el-button>
                                            <el-button v-else type="warning" plain @click="multiAdd(item.goodsId)" size="mini" >加入购物车</el-button> -->
                                            <el-button v-if="adminState == 0 || adminState == 1"  type="warning" plain @click="multiAdd(item.goodsId)" size="mini" >加入购物车</el-button>
                                            <el-button v-else  type="warning" plain @click="multiAdd(item.goodsId)" size="mini" >{{ isRmdPost ? '荐购直邮' : '荐购' }}</el-button>
                                        </div>
                                        <div v-if="item.unionGid" class="tixingShow">{{ TryBookFont }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="pagefixed cleaxfix" style="border-top:1px solid #eee;" v-if="!isNonedatas">
                                <Checkbox class="bigCheckbox fl" v-model="checkAll" :indeterminate="isIndeterminate" size="small" @change="changeCheckAll">全选</Checkbox>
                                <el-pagination class="fr" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="params.current" :page-size="params.size" layout="prev, pager, next, jumper, total" :total="total"></el-pagination>
                                <el-button v-if="adminState == 0 || adminState == 1" class="plbtn fl" type="warning" plain @click="multiAdd('0')" size="mini">批量加入购物车</el-button>
                                <el-button v-if="adminState == 2 || adminState == 3 || adminState == 4 || adminState == 5" class="plbtn fl" type="warning" plain @click="multiAdd('0')" size="mini">批量荐购</el-button>
                                <!-- <el-button type="warning" plain @click="multiAdd('1')" size="mini">全部加入购物车</el-button> -->
                            </div>
                        </div>
                        <div v-if="!filechange">
                            <table-list-book ref="listBook"></table-list-book>
                        </div>
                    </div>
                </div>
            </div>
            <bottom-component></bottom-component>
        </div>
    </div>
    </template>
    
    <script>
    import { Checkbox, Loading, DatePicker, Button } from "element-ui";
    // import TopComponent from '@/views/Components/TopComponent.vue'
    import TopComponent from '@/views/Components/TopComponentcopy'
    // import TopComponentTch from '@/views/Components/TopComponentTch';
    import BottomComponent from "@/views/Components/BottomComponent.vue";
    // import SearchComponent from "../../components/SearchComponent";
    import SearchComponent1 from "../../components/SearchComponentcopy1.vue";
    // import SearchComponent1 from "../../components/SearchComponentcopy.vue";
    import popup from "../../common/plugin/dialog/index.js";
    import keyValuePop from '../../components/textareaDialog'
    import addressManage from '../Components/addressManage.vue'
    import AddInventory from "../../components/AddInventory";
    import axios from "axios";
    import Cookies from "js-cookie";
    import { actionsave, addMoreOrder,getdiFangdata,getdetails,shoppingCartnum } from "@/api/pages";
    import Axios from "@/api/diyaxios";
    import scrollFixed from "../../common/utils/scrollfixed";
    // import tableListBook from '@/views/search/tableListBook'
    import tableListBook from '@/views/search/tableListBookcopy'
    import { insertPoint } from '@/api/insertPoints'   //添加埋点
    import Vue from 'vue'
    import { vueBaberrage, MESSAGE_TYPE } from 'vue-baberrage';
    Vue.use(vueBaberrage)
    
    export default {
        props: ['activateinfo'],//砸金蛋活动id
        name: "app",
        data() {
            let vm = this;
            return {
                logintype:localStorage.getItem('logintype'), 
                defaultAddress: JSON.parse(localStorage.getItem('user')).address,
                isRmdPost: JSON.parse(localStorage.getItem('roleInfo')).isdirectmail,//是否荐购直邮
                source: Cookies.get("source"),
                adminState:Cookies.get("adminState"),  
                filechange:true,
                checkAll: false,
                isIndeterminate: false,
                showLoading: null,
                isNonedatas: false,
                isShowType: {},
                total: null,
                showpubname:true,
                msg: '恭喜您中奖了',
                barrageIsShow: true,
                messageHeight: 3,
                boxHeight: 150,
                barrageLoop: true,
                maxWordCount: 3,
                throttleGap: 5000,
                barrageList: [],
                isBeat: false, //砸金蛋弹窗
                activateInfo: "", //活动信息
                actInfo: {},  //供应商名称
                istimer: null,
                showchubanshe:'0',
                isDoing: 0,
                curStartTime: "",
                day: 0,
                hour: "00",
                min: "00",
                second: "00",
                // 出版社-显示出版社详情
                pubShow: false,
                publisher: {
                    // remark: "",
                    gid: '',
                    orgName: ''
                    // orgLogo: "",
                },
                // 图书展示
                dataArr: [],
                tableData: [],
                TitleName: "",
                checkbookIndex: [], //定义批量勾选的书index
                params: {
                        isbns: null,
                        pubfrom: null,
                        pubto: null,
                        myfrom: null,
                        myto: null,
                        min:null,max:null,
                    size: 80,
                    current: 1,
                    // sortRules: '{"cbny": "desc"}'
                },
                startTime: {
                    disabledDate: time => {
                        if (vm.params.pubto) {
                            return (
                                time.getTime() > new Date(vm.params.pubto).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if (vm.params.pubfrom) {
                            return (
                                time.getTime() < new Date(vm.params.pubfrom).getTime()
                            );
                        }
                    }
                },
                TryBookFont:'',
                flag:false,//试读是否解析
                cbsInfo: null,//出版社logo和简介
                //封面
                fmBgArr: [require('../../assets/fm_bg/fm01.jpg'), require('../../assets/fm_bg/fm02.jpg'), require('../../assets/fm_bg/fm03.jpg'), require('../../assets/fm_bg/fm04.jpg')]
            };
        },
        created() {
            let vm = this,
                rp = JSON.parse(vm.$route.query.obj);
                if(rp.showchubanshe){
                    vm.showchubanshe = '8899'
                }else{
                    vm.showchubanshe = '0'
                }
            if (rp.gid != '0') {
                vm.isShowType.pubShow = false;
                vm.pubShow = true;
                vm.isBeat = true;
                vm.ChuDataDetail(rp.gid,rp.publisherId);//获取出版社详情
            }else{
                vm.pubShow = false;
            }
            if (rp.publicType) vm.isShowType.dzShow = false;
            if (rp.cnIbraryType){
                vm.isShowType.ztfShow = false;
                vm.ztfShow = false;
            }
            if (rp.subjectId) vm.isShowType.xkShow = false;
            if (rp.activityTag) vm.isShowType.zttagShow = false;
            (typeof rp.goodsType == 'undefined' || rp.goodsType == 1) ? vm.isShowType.goodsType = 1 : vm.isShowType.goodsType = 2;
            vm.scrollFixed("pageFixed", "bookList");
        },
        mounted() {
            let vm = this,
                rp = JSON.parse(vm.$route.query.obj); 
            // if(rp.hasOwnProperty('modeChange')){
            //     vm.pubShow = false;
            //     vm.filechange = false;
            //     vm.$nextTick(() => {
            //         console.log('676',vm.params);
            //         vm.$refs.listBook.submitForm(vm.params);
            //     });
            // }else{
                vm.params.userid = Cookies.get("UserID");
                if(rp.gid != '0') {
                    vm.params.pubid = rp.gid || rp.pubid || null;
                    // vm.params.pubname2 = rp.pubname2 || null;
                    // vm.params.pubname = rp.pubname || null;
                }
                if(rp.gid == '48401394699954321101100640992141'){//零时固定
                    vm.params.supplierName = '上海文艺出版社有限公司';
                }
                vm.TitleName = rp.TitleName;
                vm.params.pubname = rp.pubname;   // 出版社
                vm.params.dzfl = rp.publicType;  // 大众分类
                vm.params.dzflName = rp.title;  //大众分类名称
                vm.params.ztf = rp.cnIbraryType;  // 中图分类
                vm.params.ztfName = rp.zttitle;  //中图分类名称
                vm.params.xkfl = rp.subjectId;    // 学科类别
                vm.params.zxkName = rp.xuekeTitle; //学科分类名称
                vm.params.activitytag = rp.activityTag; //this.$route.params.activityTag // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
                vm.params.goodsType = rp.goodsType; //this.$route.params.goodsType // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
                if(rp.goodsType == '1'){
                    vm.TryBookFont = '有电子书';
                }else if(rp.goodsType == '2'){
                    vm.TryBookFont = '有纸质书';
                }
                // if (rp.gid != '0') vm.ChuDataDetail();
                if(rp.eventId){
                    let doId = +localStorage.getItem('doId') + 1;
                    localStorage.setItem('doId', doId);
                    insertPoint(vm.params, 'click', rp.eventId, doId); //添加埋点
                }
                vm.DiFangData(vm.params);
            // }
        },
        methods: {
            open1() {
            this.$message('活动还未开始');
          },
            scrollFixed,
            //获取出版社信息（logo和简介）
            // getCbsInfo(pkid){
            //     let vm = this;
            //     Axios.post('/api/csuppliers/action/get', {
            //         params:{
            //             // pkid: pkid
            //             pkid: '1245'
    
            //         }
            //     }, {
            //             headers: {
            //                 "Content-Type": "application/json"
            //             }
            //         }
            //     ).then(res => {
            //         if(res.status){
            //             vm.cbsInfo = res.data;
            //             console.log(vm.cbsInfo,'vm.cbsInfo');
            //         }
            //     });
            // },
    
            goChangeAddress(){
                // const router = this.$router.resolve({
                //     path: '/addressmanagement',
                // })
                // window.open(router.href)
                let vm = this;
                vm.edit_pop = popup('<address-manage @close="close" @submit="submit" :changetype="type" />', {
                    option: {
                        title: '切换默认地址',
                        width: '800px'
                    },
                    popup: {
                        data() {
                            return {
                                type: 0, //0：切换默认地址
                            };
                        },
                        components: {
                            addressManage
                        },
                        methods: {
                            submit(data) {            
                                vm.defaultAddress = data.address; 
                                vm.edit_pop.hide();
                            },
                            close(){
                                vm.edit_pop.hide();
                            }
                        }
                    }
                });
                vm.edit_pop.show();
            },
    
            beforeAddCar(obj){
                return new Promise((resolve, reject)=>{
                    let vm = this;
                    Axios.post('/goods/action/check', { params: JSON.stringify(obj.goodsIdList)},
                        {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    ).then(res => {
                        let datalist = res.data || {};
                        if(datalist.notDuplicateGoods && datalist.notDuplicateGoods == 0){//无重复
                            resolve(obj)
                        }else{//有重复
                            vm.$confirm("重复采购，是否继续提交？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: "warning"
                            }).then(() => {
                                //全部数组
                                resolve(obj)
                            }).catch(() => {});
                        }
                    });
                });
            },
    
            errorHandler(event) {
                event.target.classList.add('error')
            },
            fileChange(val){
                let vm = this;
                vm.params.current = 1;
                if(val == 1){
                    vm.filechange = true;
                    vm.params.size = 80;
                    vm.DiFangData(vm.params);
                }else if(val == 2){
                    vm.params.size = 20;
                    vm.filechange = false;
                    vm.$nextTick(() => {
                        vm.$refs.listBook.submitForm(vm.params);
                    });
                }
            },
            submitForm(data) {
                let vm = this,
                    rp = JSON.parse(vm.$route.query.obj);
                vm.params.current = 1;
                vm.params.size = !vm.filechange ? 20 : 80;
                // vm.params = {
                //     current: 1,
                //     size: !vm.filechange ? 20 : 80,
                //     goodstype: vm.params.goodstype
                // };
                // if (typeof vm.isShowType.dzShow != "undefined") data.dzfl = vm.params.dzfl;
                // if (typeof vm.isShowType.xkShow != "undefined") data.xkfl = vm.params.xkfl;
                if (typeof vm.isShowType.zttagShow != "undefined") data.activitytag = vm.params.activitytag;
                // if (typeof vm.isShowType.ztfShow != "undefined") data.ztf = vm.params.ztf;
                // (typeof this.isShowType.goodsType == 'undefined' || this.isShowType.goodsType == 1) ? data.goodsType = 1 : data.goodsType = 2;
                delete vm.params.ztfName;
                delete vm.params.zxkName;
                delete vm.params.dzflName;
                delete vm.params.classifydata;
                // data.sortRules = vm.params.sortRules;
                if(!rp.hasOwnProperty('modeChange') && vm.params.pubid != '0' && data.pubname == null && data.pubname2 == null) {
                    data.pubid = vm.params.pubid || null;
                    data.pubname2 = vm.params.pubname2 || null;
                    data.pubname = vm.params.pubname || null;
                }
                for(var a in data){
                    // if(data[a] && !vm.params[a]) vm.params[a] = data[a];
                    // if(data[a]) vm.params[a] = data[a];
                     vm.params[a] = data[a];
                }
                // vm.params = data;
                // this.params.goodstype = JSON.parse(this.$route.query.obj).goodsType;
                // this.searchData = this.params;
                if(vm.filechange){
                    vm.DiFangData(vm.params);
                }else{
                    vm.$refs.listBook.submitForm(vm.params);
                }
            },
            changeCheckAll(flag) {
                let vm = this;
                vm.isIndeterminate = false;
                if (flag) {
                    //全选
                    //清空
                    vm.checkbookIndex = [];
                    vm.dataArr.forEach((ele, i) => {
                        vm.$set(vm.dataArr[i], "ckb", true);
                        vm.$set(vm.dataArr[i], "ckb", true);
                        vm.checkbookIndex.push(i);
                    });
                    vm.checkAll = true;
                } else {
                    // 取消全选
                    //清空
                    vm.checkbookIndex = [];
                    vm.dataArr.forEach((ele, i) => {
                        vm.$set(vm.dataArr[i], "ckb", false);
                    });
                    vm.checkAll = false;
                }
            },
            changeCheck(index) {
                let vm = this,
                    arr = vm.checkbookIndex;
                if (arr.indexOf(index) > -1) {
                    arr.splice(arr.indexOf(index), 1);
                    vm.$set(vm.dataArr[index], "ckb", false);
                } else {
                    arr.push(index);
                    vm.$set(vm.dataArr[index], "ckb", true);
                }
                // arr.sort(function(a,b){
                //     return a-b;
                // });
                if (arr.length == vm.dataArr.length) {
                    vm.checkAll = true;
                    vm.isIndeterminate = false;
                } else if (arr.length > 0 && arr.length < vm.dataArr.length) {
                    vm.checkAll = false;
                    vm.isIndeterminate = true;
                } else if (arr.length == 0) {
                    vm.checkAll = false;
                    vm.isIndeterminate = false;
                }
                vm.checkbookIndex = arr;
                // console.log(vm.checkbookIndex);
            },
            //批量加入购物车
            multiAdd(type) {
                let vm = this;
                if (Cookies.get("token")) {
                    if (type == "0") {
                        //批量加入购物车
                        let checkedList = [];
                        if (vm.checkbookIndex.length > 0) {
                            //获取批量勾选的数据
                            for (var i in vm.checkbookIndex) {
                                checkedList.push(
                                    vm.dataArr[vm.checkbookIndex[i]].goodsId
                                );
                            }
                            //普通用户只能荐购一本书
                            if(vm.adminState == '0' || vm.adminState == '1'){
                                vm.showAmountPop(checkedList);
                            }else{
                                vm.addCarbyBooks(checkedList);
                            }
                        } else {
                            vm.$message({
                                message: "请至少勾选中一本书！",
                                type: "warning"
                            });
                        }
                    } else if (type == "1") {
                        // 全部加入购物车
                        let checkedList = [];
                        vm.dataArr.forEach(ele => {
                            checkedList.push(ele.goodsId);
                        });
                        vm.showAmountPop(checkedList);
                    } else {
                        //单个加入购物车
                        let checkedList = [];
                        checkedList.push(type);
                        // vm.showAmountPop(checkedList);
                        vm.addCarbyBooks(checkedList);
                    }
                } else {
                    localStorage.setItem('pageUrl', `/${window.location.hash}`);
                    vm.$router.push({
                        name: "Login"
                        // params: { type: "LookPublishingPagesType", params:vm.$route.params }
                    });
                }
            },
            //批量或单个加入荐购
            addCarbyBooks(list){
                let vm = this, 
                    obj = {
                        goodsIdList: list,
                        userId: Cookies.get("UserID"),
                        source:Cookies.get("source"),
                        amount: 1
                    };
                vm.beforeAddCar(obj).then(function(obj){
                    addMoreOrder(obj).then(res => {
                        if(res.status){                                    
                            if(vm.adminState == 0 || vm.adminState == 1 ){
                                vm.$message({
                                    message: '加入购物车成功',
                                    type: 'success',
                                    duration:800
                                });
                            }else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5){
                                vm.$message({
                                    message: '荐购成功',
                                    type: 'success'
                                }); 
                            }   
                            vm.getShopCarData()
                            //添加“加入购物车”埋点
                            let doId = +localStorage.getItem('doId') + 1;
                            localStorage.setItem('doId', doId);
                            insertPoint(obj, 'click', 'shop', doId); //添加埋点                            
                            vm.DiFangData(vm.params);
                        }else if(res.code == '10000'){
                            vm.$confirm('您还没有收货地址，需要设置收货地址才可以荐购，需要设置吗？', '提示', {
                                confirmButtonText: '前往设置',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                // const router = this.$router.resolve({
                                //     path: '/addressmanagement',
                                // })
                                // window.open(router.href)
                                vm.goChangeAddress();
                            }).catch(() => {
    
                            });
                        }
                    }).catch(err => {
                        vm.$message({
                            message: err.res.errorMsg,
                            type: 'error',
                            duration: 800
                        });
                    });
    
                })
            },
            //选择复本数弹窗
            showAmountPop(goodsIds) {
                let vm = this;
                vm.addivent_pop = popup(
                    '<add-inventory @cancel="close" @submit="submit" :objdata="objData"/>',
                    {
                        option: {
                            title: "设置采购数量",
                            width: "433px",
                            customClass: "pop-add-list"
                        },
                        popup: {
                            data() {
                                return {
                                    objData: {
                                        gids: goodsIds
                                    }
                                };
                            },
                            components: {
                                AddInventory
                            },
                            methods: {
                                submit(data) {
                                   vm.getShopCarData()
                                    vm.DiFangData(vm.params);
                                    vm.addivent_pop.hide();
                                },
                                close(data) {
                                    vm.addivent_pop.hide();
                                }
                            }
                        }
                    }
                );
                vm.addivent_pop.show();
            },
            // 展示购物车数据
            async getShopCarData() {
                let data = {
                    userId: Cookies.get("UserID"),
                };
                let res = await shoppingCartnum(data)
                if(res.code == '200'){
                    this.$store.state.DataStorage.GoodLengthData = res.data;
                }
            },
            // 获取详情
            async ChuDataDetail(gid,publisherId) {
                let vm = this,
                    obj = {
                        orgType: 7,
                        orgName: JSON.parse(this.$route.query.obj).pubname2 || JSON.parse(this.$route.query.obj).pubname
                    }; 
                    let res = await getdetails(obj)
                    if(res.code == '200'){
                        // vm.publisher.orgLogo = res.data.list[0].orgLogo;
                        // vm.publisher.orgName = res.data.list[0].orgName;
                        let pubGid = res.data.list[0].gid;
                        // vm.getCbsInfo(pubGid);  //获取出版社信息（logo和简介）
                        // vm.$refs.topRef.getNowActiveInfo(); //获取当前砸金蛋活动的供应商
                        //判断是否是点击“砸金蛋”进入此页面（只有点击才会弹出“砸金蛋”窗口）
                        if(JSON.parse(this.$route.query.obj).hasOwnProperty('isHandleBeat')){  //是，
                            // vm.$refs.topRef.isBeat = true; //打开“砸金蛋”弹出窗
                            vm.$refs.topRef.getNowActiveInfo(); //获取当前砸金蛋活动的供应商
                        }else{  //不是
                            vm.$refs.topRef.isBeat = false; //不打开“砸金蛋”弹出窗
                          vm.$refs.topRef.isjieguo = false;
                        }
                    }
            },
            // 获取数据
            async DiFangData(params) {
                let vm = this
                    // url = "/proxydf/purch/v2/rmdsupport/pb/rmdsupport/action/search";
                vm.showLoading = Loading.service({
                    target: "body",
                    spinner: "el-icon-loading",
                    text: "加载中...",
                    background: "rgba(255, 255, 255, 0.5)"
                });
                this.isNonedatas = false;
                let res = await getdiFangdata(params)
                if(res.code == '200'){
                    vm.showLoading.close();
                    //提交清空已勾选
                    vm.checkbookIndex = [];
                        vm.checkAll = false;
                        vm.isIndeterminate = false;
                        if (res.data.records.length > 0) {
                            this.isNonedatas = false;
                            vm.dataArr = res.data.records;
                            vm.total = res.data.total;
                            vm.dataArr.forEach((ele, i) => {
                                vm.$set(vm.dataArr[i], 'ckb', false);
                                if(!ele.hasOwnProperty('imageUrl')||ele.imageUrl==null){
                                    let isbnStr = ele.isbn.replace(/-/g,''),
                                    bgIndex = isbnStr%3; //随机生成0~3之间的数字
                                    // let bgIndex = Math.floor((Math.random()*4)); //随机生成0~3之间的数字
                                    vm.$set(vm.dataArr[i], 'isImageUrl', false);
                                    vm.$set(vm.dataArr[i], 'imageUrl', vm.fmBgArr[bgIndex]);
                                }else{
                                    vm.$set(vm.dataArr[i], 'isImageUrl', true);
                                }
                                if(ele.delivery == 0) {
                                    ele.delivery = "期货"
                                }
                                if(ele.delivery == 1) {
                                    ele.delivery = "现货"
                                }
    
                            });
                        } else {
                            this.isNonedatas = true;
                }
            }else{
                    vm.$message({
                            message: err.errorMsg || '查询出错！',
                            type: 'error'
                        })
                        vm.showLoading.close();
                }
            },
            // 筛选排序
            filterChange(filters) {
                let rule = {},
                    sort;
                // this.$refs.djSort.clearSort();
                // this.$refs.cbnySort.clearSort();
                if (filters.order === "descending") {
                    sort = "desc";
                } else if(filters.order === "ascending") {
                    sort = "asc";
                }else{
                    sort = '';
                }
                if(sort != ''){
                    rule[filters.prop] = sort;
                    this.params.sortRules = JSON.stringify(rule);
                 }else{
                    rule={};
                    delete this.params.sortRules;
                 }
                // Cookies.set('PublishingPagesTypeIdOrderBy', this.params.sortRules)
                this.DiFangData(this.params);
            },
            //
            onSubmitResult(){
                console.log(this.params);
                this.DiFangData(this.params);
            },
            // 点击跳转详情页
            BookDetailClick(item) {
                const { href } = this.$router.resolve({
                    name: "BookDetail",
                    params: { goodsId: item.goodsId }
                });
                window.open(href, "_blank");
            },
            // 试读
            TryBook(item) {
                window.open(item.readEntryUrl);
            },
            async getBookFile(res,bib){
                res = res.data;
                let vm = this;
                if (res && res.length > 0) {
                        if(res.length>1){
                                var type = null;
                                for(var i = 0; i<res.length; i++){
                                        if(!vm.flag){
                                                type = res[i];
                                                vm.flag = await vm.getFileTransferStatus(type,bib);
                                        }
                                }
                        }else{
                                vm.flag = await vm.getFileTransferStatus(res[0],bib);
                        }
                        if(!vm.flag){
                            vm.$message({
                                message: "请首先通过本地解析器解析电子书文件...",
                                type: "info",
                                duration:800
                            });
                        }
                }
            },
            getFileTransferStatus(type,bibGid){
                let vm = this;
                return new Promise((resolve,reject)=>{
                    axios.get(`/ytzhihui/ecp/service?callName=com.cloud.ereader.service.IEbookTransferService.queryEbookTransferByBibGid(map)&bibGid=${bibGid}&fileType=${type}`, { params: {}}
                        ).then(res => {
                            if(res.data && res.data.status == 1) {
                                    var d = res.data.result,
                                    flag = false;
                                    if(d && d.bookId){
                                            flag = true;
                                            var booksId = d.bookId;
                                            if(type=="pdf"){
                                                    window.open('http://ebook.ytzhihui.com/pdf-mobile/?booksId='+booksId+'&userId=2020011717074604777');
                                            }else if(type=="epub"){
                                                    window.open('http://ebook.ytzhihui.com/book-h5/?booksId='+booksId+'&userId=2020011717074604777');
                                            }else if(type=="txt"){
                                                    window.open('http://ebook.ytzhihui.com/book/?booksId='+booksId+'&userId=2020011717074604777');
                                            }
                                    }else{
                                            flag = false;
                                    }
                                    resolve(flag)
                            }
                        }).catch(err => {
                    });
                });
            },
            getArguments(url) {//获取地址栏参数
                if (arguments.length === 0) {
                    url = location.href;
                }
                url = decodeURI(url);
                var argObj = {};
                var urlSplit = url.split("?");
                if (urlSplit.length > 1) {
                    var args = urlSplit[1].replace("#","&").split("&");
                    for (var i = 0; i < args.length; i++) {
                        var arg = args[i].split("=");
                        argObj[arg[0]] = arg[1];
                    }
                }
                return argObj;
            },
            // 添加购物车
            async AddSohpCar(item) {
                // console.log(item)
                if (Cookies.get("token")) {
                    var obj = {
                        goodsId: item.goodsId,
                        gid: item.gid,
                        userId: Cookies.get("UserID"),
                        source:Cookies.get("source"),
                        amount: 1,
                        isAddCart: 1 // 0代表从计数器点的  1代表从商品点的
                    };
                    this.showLoading = Loading.service({
                        target: "body",
                        spinner: "el-icon-loading",
                        text: "加载中...",
                        background: "rgba(255, 255, 255, 0.5)"
                    });
                    let res = await actionsave(obj)
                    if(res.code == '200'){
                        // console.log(response)
                        this.$nextTick(() => {
                            // 以服务的方式调用的 Loading 需要异步关闭
                            this.showLoading.close();
                        });
                        if(this.adminState == 0 || this.adminState == 1 ){
                      this.$message({
                      message: '加入购物车成功',
                      type: 'success',
                      duration:800
                     });
                    }else if (this.adminState == 2 || this.adminState == 3 || this.adminState == 4 || this.adminState == 5){
                      this.$message({
                      message: '荐购成功',
                      type: 'success'
                    }); 
                    }
                        this.getShopCarData()
                    }else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                            duration:800
                        });
                }
                    // actionsave(obj).then(response => {
                    //     // console.log(response)
                    //     this.$nextTick(() => {
                    //         // 以服务的方式调用的 Loading 需要异步关闭
                    //         this.showLoading.close();
                    //     });
                    //     this.$message({
                    //         message: "加入购物车成功！",
                    //         type: "success",
                    //         duration:800
                    //     });
                    // });
                } else {
                    localStorage.setItem('pageUrl', `/${window.location.hash}`);
                    this.$router.push({name: 'Login'});
                }
            },
            // 分页
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                this.params.current = val;
                this.DiFangData(this.params);
                // Cookies.set('PublishingPagesTypecurrentPage', val)
            },
            multiplePop(txt, flag) {
                let vm = this,
                    val = '';
                val = vm.params[flag];
                vm.key_pop = popup('<key-value-pop @close="close" @ok="submit" :msg="msg" />', {
                    option: {
                        title: `多个${txt}批量查询`,
                        width: '336px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: {
                                    val: val,
                                    flag: flag
                                }
                            }
                        },
                        components: {
                            keyValuePop
                        },
                        methods: {
                            submit(data) {
                                let flag = data.flag;
                                vm.params[flag] = data.val;
                                vm.key_pop.hide();
                            },
                            close() {
                                vm.key_pop.hide();
                            }
                        }
                    }
                })
                vm.key_pop.show();
            },
            //清除
            clearValue(prop, val, data) {
                const index = this.selectedOptionsall.indexOf(this.tempform.isbns);
                if (index !== -1) {
                    this.selectedOptionsall.splice(index, 1);
                    this.tempform.isbns = ''
                    this.onSubmit()  // 检索
                }
                let vm = this;
                vm.tempform[prop] = null;
                if (val) vm[val] = null;
                if (data) vm.tempform[data] = null;
            },
        },
        components: {
            TopComponent,
            // TopComponentTch,
            BottomComponent,
            SearchComponent1,
            tableListBook,
            Checkbox,
            Loading,
            DatePicker,
            Button
            // ZjdComponent,
        }
    };
    </script>
    
    <style lang="scss">
    @import "../../style/booklist";
    .supply_wrap{
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .clearfixed:after{
        content:'';
        display: block;
        height: 0;
        line-height: 0;
        overflow: hidden;
        clear: both;
    }
    .content_wrap{
            padding: 20px;
            
        }
    .list_wrap{
        .tab{
            background-color: #f4f4f5;
            .el-table th.el-table__cell.is-leaf{
                border-bottom:0 none;
            }
            .el-table th.el-table__cell{
                background: #f4f4f5;
            }
            .el-table::before{
                background-color: initial;
            }
            .el-date-editor{
                &.el-input--suffix .el-input__inner{
                    padding-left:25px;
                }
            }
            .el-input--suffix .el-input__inner{
                padding: 0 5px;
            }
        }    
        .itemline{
            padding-right: 10px;
            margin-right: 8px;
            background: url('../../assets/images/itemline.png') no-repeat right center;
            // border-right:1px solid #999;
        }
        .line{
            text-align: center;
            font-weight: normal;
            color: #969696;
        }
    }
    .LookMenu-container{
                background-color: #fff;
                padding:10px;
            }
        .titleName{
            width: 100%;
            position: relative;
            height:40px;
        }
        .right_word{
            width: 100%;
            bottom: 25px;
            left:0;
            position: absolute;
            text-align: center;
            font-size:12px;
            color:#999;
        }
        .changeMode{
            // float:right;
            position: absolute;
            right:10px;
            top:10px;
            .listfont{
                display: inline-block;
                margin-left:-1px;
                width: 32px;
                height: 32px;
                border-radius: 2px 0 0 2px;
                border: 1px solid #DCDFE6;
                line-height: 28px;
                text-align: center;
                background-color: #fff;
                cursor: pointer;
                i{
                    display: block;
                    width: 24px;
                    height: 24px;
                    margin:4px;
                    background-repeat: no-repeat;
                    background-size:100%;
                }
                i.boxIcon{
                    background-image: url("../../assets/images/boxlist.png");
                }
                i.listIcon{
                    background-image: url("../../assets/images/tablist.png");
                }
            }
            .filecurrent{
                i.boxIcon{
                    background-image: url("../../assets/images/boxlist_cur.png");
                }
                i.listIcon{
                    background-image: url("../../assets/images/tablist_cur.png");
                }
            }
        }
        .zjdBg {
        /* position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        z-index: 100;
        overflow-y: hidden; */
        .zjdContent {
            height: 100%;
            color: #fff;
            .supplier {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: cadetblue;
            }
            .nextTime {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fb7d0f;
                span {
                    margin: 0 20px;
                }
            }
            .activityContent {
                display: flex;
                height: 100%;
                .Sessions {
                    width: 100%;
                    height: 100%;
                    line-height: 50px;
                    text-align: center;
    
                }
            }
            .times {
                display: flex;
                justify-content: space-evenly;
                span {
                    display: block;
                }
            }
            .priceInfo {
                width: 100%;
                .barrages-drop {
                    .blue {
                        border-radius: 100px;
                        background: #e6ff75;
                        color: #fff;
                    }
    
                    .green {
                        border-radius: 100px;
                        background: #75ffcd;
                        color: #fff;
                    }
                    .red {
                        border-radius: 100px;
                        background: #e68fba;
                        color: #fff;
                    }
                    .yellow {
                        border-radius: 100px;
                        background: #dfc795;
                        color: #fff;
                    }
                }
            }
        }
    }
    .zjdClose {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 20px;
        right: 20px;
        cursor: pointer;
        z-index: 109;
    }
    .zjdBox {
        width: 420px;
        height: 520px;
        position: relative;
        // position: fixed;
        // z-index: 101;
        // top:50%;
        // left:50%;
        // margin-top:-260px;
        // margin-left: -210px;
    }
    .Sign {
        height: 300px;
        text-align: center;
        display: flex;
        padding: 0;
        flex-direction: column;
        justify-content: space-around;
        color: #000;
        .success {
            font-size: 22px;
        }
        .continuity {
            font-size: 25px;
        }
        .el-button {
            margin-bottom: 50px;
        }
        p {
            text-align: left;
            display: flex;
            justify-content: center;
        }
    }
    .zjdGet {
        position: fixed;
        top: 20px;
        left: 20px;
        background: rgba(0, 0, 0, 0.3);
        width: 90px;
        // height: 120px;
        text-align: center;
        cursor: pointer;
        // z-index: 99;
    }
    .zjdimg img {
        width: 60px;
    }
    .zjdtext {
        color: #fff;
        font-size: 12px;
        line-height: 30px;
        > b {
            font-weight: normal;
        }
    }
    .suppldetaiboxd{
        margin: 0 auto;
        width: 100%;
      }
      .suppldetaibox {
        margin: 0 auto;
        width: 80%;
        background-color: #fff; 
        /* background-color: #b82830; */
    
           
      }
    }
    </style>
    


// WEBPACK FOOTER //
// src/views/ChildPages/Look-Publishing-PagesTypecopy.vue